import { unicodeHelperWith } from "./unicode-helper";
import { defaultPairs } from "./default";
export const unicodeHelper = unicodeHelperWith(defaultPairs);
export { unicodeHelperWith };
//# sourceMappingURL=index.js.map